export default __webpack_public_path__ + "static/media/ios.ee152ae6.svg";